import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StepByStepBirthdayFlow from './components/StepByStepBirthdayFlow';
import BirthdayCoffee from './components/birthday.coffee/BirthdayCoffee';
import SecretsManager from './components/SecretsManager';
import CRUDFlowTest from './components/CRUDFlowTest';
import EmailTest from './components/EmailTest';
import DNSChecker from './components/DNSChecker';
import MonetizationFlowDiagram from './components/MonetizationFlowDiagram';
import AnimatedBirthdayCards from './components/AnimatedBirthdayCards';
import TestingFlow from './components/TestingFlow';
import DecisionTree from './components/DecisionTree';
import InteractiveDecisionTree from './components/InteractiveDecisionTree';
import BirthdayHub from './components/BirthdayHub';
import AdminDashboard from './components/AdminDashboard';
import LinksDirectory from './components/LinksDirectory';
import CardView from './components/CardView';
import BirthdayMonthCapture from './components/BirthdayMonthCapture';

function App() {
  return (
    <Routes>
      <Route path="/" element={<StepByStepBirthdayFlow />} />
      <Route path="/hub" element={<BirthdayHub />} />
      <Route path="/view/:id" element={<CardView />} />
      <Route path="/birthdays/:month" element={<BirthdayMonthCapture />} />
      <Route path="/cards" element={<StepByStepBirthdayFlow />} />
      <Route path="/card/:template/:name" element={<StepByStepBirthdayFlow />} />
      <Route path="/cards-old" element={<AnimatedBirthdayCards />} />
      <Route path="/landing" element={<BirthdayCoffee />} />
      <Route path="/test" element={<TestingFlow />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/secrets" element={<SecretsManager />} />
      <Route path="/admin/crud-test" element={<CRUDFlowTest />} />
      <Route path="/admin/email-test" element={<EmailTest />} />
      <Route path="/admin/dns" element={<DNSChecker />} />
      <Route path="/admin/monetization" element={<MonetizationFlowDiagram />} />
      <Route path="/admin/decision-tree" element={<DecisionTree />} />
      <Route path="/admin/interactive-tree" element={<InteractiveDecisionTree />} />
      <Route path="/links" element={<LinksDirectory />} />
    </Routes>
  );
}

export default App;
